module.exports = __webpack_public_path__ + "prod/1.42.2/img/new-mode-three.50f6fe0d.png";